/*
 * @Author: Michael 
 * @Date: 2018-09-17 10:13:35 
 * @Last Modified by: Michael
 * @Last Modified time: 2018-09-17 18:38:59
 * loading插件
 */
import _Vue, { VueConstructor } from 'vue';
import LoadingComponent from './Loading.vue';

let $vm: any;

export default {
  install(Vue: typeof _Vue) {
    if (!$vm) {
      const LoadingPlugin: VueConstructor = Vue.extend(LoadingComponent);

      $vm = new LoadingPlugin({
        el: document.createElement('div')
      });

      document.body.appendChild($vm.$el);
    }

    $vm.show = false;
    const loading = {
      show(text: string) {
        $vm.show = true;
        if (text) {
          $vm.text = text;
        }
      },

      hide() {
        $vm.show = false;
      }
    };

    if (!Vue.$loading) {
      Vue.$loading = loading;
    }

    Vue.mixin({
      created() {
        this.$loading = Vue.$loading;
      }
    });
  }
};